import {useContext} from "react";
import {AuthContext, AuthContextType} from "@contexts/AuthContext.tsx";

/**
 * @see AuthProvider
 */
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within a AuthProvider');
    }
    return context as AuthContextType
};